import { render, staticRenderFns } from "./NotesContainer.vue?vue&type=template&id=6c43302b&scoped=true&"
import script from "./NotesContainer.vue?vue&type=script&lang=js&"
export * from "./NotesContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotesContainer.vue?vue&type=style&index=0&id=6c43302b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c43302b",
  null
  
)

export default component.exports